
export const common = {
  // Navigation
  'nav.home': 'Inicio',
  'nav.treatments': 'Tratamientos',
  'nav.howItWorks': 'Cómo funciona',
  'nav.supervision': 'Supervisión',
  'nav.about': 'Nosotros',
  'nav.bookNow': 'Reservar ahora',
  'nav.language': 'Idioma',

  // Hero
  'hero.badge': 'Médicos reales. Cuidado real. Tranquilidad real.',
  'hero.title.line1': 'Mereces una sonrisa',
  'hero.title.line2': 'De la que estés orgulloso',
  'hero.subtitle1': 'Ya sea un dolor que has ignorado, una sonrisa que has ocultado, o costos que te han hecho esperar — ya no tienes que esperar más.',
  'hero.subtitle2': 'Hacemos que la atención dental de clase mundial en Turquía sea segura, respaldada y completamente a tu alcance — con un médico supervisando cada paso.',
  'hero.cta.primary': 'Comenzar mi viaje',
  'hero.cta.secondary': 'Hablar con alguien primero',
  'hero.feature1': 'Supervisado por un médico de principio a fin',
  'hero.feature2': 'Atención que se adapta a tu vida y presupuesto',
  'hero.feature3': 'Apoyado en cada paso, cerca o lejos',

  // Services
  'services.badge': 'Tu viaje comienza aquí',
  'services.title': 'Tratamientos que cambian cómo te sientes cada día',
  'services.subtitle': 'Ya sea que estés listo para sonreír sin dudarlo, comer sin preocupaciones, o simplemente sentirte tú mismo de nuevo — estamos aquí para ayudarte',
  'services.cta': 'Explorar todos los tratamientos',
  'services.swipeHint': 'Desliza para explorar más tratamientos',
  'services.learnMore': 'Saber más',
  'services.startingFrom': 'Desde',
  'services.perTooth': 'por diente',

  'service.implants.title': 'Implantes dentales',
  'service.implants.desc': 'Come, ríe y habla con plena confianza. Siéntete tú mismo con dientes que lucen, se sienten y funcionan como los naturales.',
  'service.veneers.title': 'Carillas de porcelana',
  'service.veneers.desc': 'Deja de esconder tu sonrisa en las fotos. Despierta cada día amando lo que ves en el espejo con una sonrisa que finalmente se siente tuya.',

  'service.smile.title': 'Cambio de sonrisa',
  'service.smile.desc': 'Transforma cómo te sientes contigo mismo. Un cambio completo de sonrisa diseñado alrededor de tu rostro, tu vida y la confianza que mereces.',

  'service.orthodontics.title': 'Ortodoncia',
  'service.orthodontics.desc': 'Endereza tus dientes sin la incomodidad. Tratamiento discreto que se adapta a tu estilo de vida y te da la sonrisa que siempre quisiste.',

  'service.whitening.title': 'Blanqueamiento dental',
  'service.whitening.desc': 'Siéntete seguro en cada conversación. Una sonrisa más brillante y blanca que te hace sentir bien cada vez que hablas.',

  'service.root.title': 'Tratamiento de conducto',
  'service.root.desc': 'Deja de vivir con dolor dental. Salva tu diente natural y vuelve a disfrutar la vida sin molestias ni preocupaciones constantes.',

  'service.crowns.title': 'Coronas dentales',
  'service.crowns.desc': 'Protege y restaura dientes dañados para poder comer lo que amas de nuevo. Coronas fuertes y de apariencia natural que duran años.',

  'service.allon4.title': 'Implantes All-on-4',
  'service.allon4.desc': 'Recupera tu vida en un solo día. Un conjunto completo de dientes permanentes que te permiten comer, sonreír y vivir sin límites.',

  // How It Works
  'how.badge': 'Proceso simple',
  'how.title': 'Cómo funciona',
  'how.subtitle': 'Cuatro pasos simples para obtener atención dental de clase mundial con total transparencia',
  'how.cta': 'Comenzar tu viaje',

  'how.step1.number': '01',
  'how.step1.title': 'Reserva tu tratamiento',
  'how.step1.desc': 'Elige tu tratamiento dental y sube tus radiografías o escaneos. Nuestro equipo revisará y creará un plan de tratamiento personalizado.',

  'how.step2.number': '02',
  'how.step2.title': 'Elige la supervisión',
  'how.step2.desc': 'Selecciona tu opción de supervisión preferida: médico tercero independiente, tu propio dentista (recibe 10%), o nuestro experto interno.',

  'how.step3.number': '03',
  'how.step3.title': 'Recibe tratamiento con transparencia',
  'how.step3.desc': 'Recibe tu tratamiento en nuestra clínica acreditada por JCI. Tu supervisor revisa todas las radiografías, escaneos y el progreso en tiempo real.',

  'how.step4.number': '04',
  'how.step4.title': 'Seguimiento',
  'how.step4.desc': 'Continúa el cuidado con tu dentista que tiene pleno conocimiento de tu tratamiento. Proporcionamos todos los registros y apoyo continuo.',

  // Supervision
  'supervision.badge': 'Estás protegido en cada paso',
  'supervision.title': '¿Preocupado por ir al extranjero para atención dental?',
  'supervision.subtitle': 'Esa preocupación es completamente válida — y es exactamente por eso que construimos esto. Cada paciente tiene un supervisor dedicado que vigila su tratamiento desde el primer día hasta el último.',
  'supervision.swipeHint': 'Desliza para explorar opciones',
  'supervision.chooseOption': 'Elige esta opción al reservar',

  'supervision.option1.title': 'Médico tercero independiente',
  'supervision.option1.badge': 'Más confiable',
  'supervision.option1.desc': 'Alguien de tu lado que solo responde ante ti — no ante la clínica. Revisan cada escaneo, aprueban cada paso y se aseguran de que nada se pierda.',
  'supervision.option1.feature1': 'Revisa tus radiografías antes de que comience cualquier cosa',
  'supervision.option1.feature2': 'Aprueba tu plan de tratamiento de forma independiente',
  'supervision.option1.feature3': 'Hace seguimiento en cada etapa de tu atención',
  'supervision.option1.feature4': 'Confirma que el resultado final cumple el estándar',
  'supervision.option1.feature5': 'Cero conflicto de intereses — trabajan para ti',
  'supervision.option1.pricing': 'Lo que obtienes: Supervisión independiente completa',

  'supervision.option2.title': 'Tu propio dentista',
  'supervision.option2.badge': 'Más cómodo',
  'supervision.option2.desc': 'El dentista en quien ya confías sigue siendo parte de tu viaje. Conoce tu historial, te conoce a ti — y se mantiene informado en cada paso.',
  'supervision.option2.feature1': 'Tu dentista recibe todos los registros y escaneos',
  'supervision.option2.feature2': 'Informado en cada etapa del tratamiento',
  'supervision.option2.feature3': 'Maneja tu seguimiento en casa',
  'supervision.option2.feature4': 'Gana el 10% del costo del tratamiento por su tiempo',
  'supervision.option2.feature5': 'Continuidad perfecta — sin empezar de cero',
  'supervision.option2.pricing': 'Lo que obtienes: Atención familiar, sin brechas',

  'supervision.option3.title': 'Nuestro experto interno',
  'supervision.option3.badge': 'Incluido',
  'supervision.option3.desc': 'Un especialista senior con más de 15 años de experiencia supervisa tu tratamiento en el lugar. Nunca eres solo un paciente — eres una prioridad.',
  'supervision.option3.feature1': 'Más de 15 años de experiencia especializada',
  'supervision.option3.feature2': 'Presente en la clínica durante toda tu atención',
  'supervision.option3.feature3': 'Responde de inmediato si algo no está bien',
  'supervision.option3.feature4': 'Mantiene cada paso al más alto estándar',
  'supervision.option3.feature5': 'Ya incluido — sin costo adicional para ti',
  'supervision.option3.pricing': 'Lo que obtienes: Ojos expertos, siempre presentes',

  'supervision.why.title': 'No deberías tener que simplemente esperar lo mejor',
  'supervision.why.desc': 'Ir al extranjero para tratamiento dental requiere valentía. Estás confiando en personas que nunca has conocido, en un país que quizás no conoces, con algo tan personal como tu sonrisa. Construimos nuestro sistema de supervisión porque creemos que mereces más que una promesa — mereces una persona real que vigile cada decisión tomada sobre tu atención.',

  // CTA
  'cta.title.line1': 'Tu sonrisa ha estado',
  'cta.title.line2': 'Esperando demasiado tiempo',
  'cta.subtitle1': 'Sabemos que no es fácil dar este paso. La incertidumbre, las preguntas, los "y si" — los escuchamos todos los días. Es exactamente por eso que estamos aquí.',
  'cta.subtitle2': 'Tu primera conversación es gratuita, sin presión y completamente en tus términos. Solo habla con nosotros — nosotros nos encargamos del resto.',
  'cta.button.primary': 'Estoy listo para hablar',
  'cta.button.secondary': 'Chatear en WhatsApp',
  'cta.badge1': 'Médicos reales. Cuidado real.',
  'cta.badge2': 'Sin presión. Sin prisas.',
  'cta.badge3': 'Apoyado en cada paso.',
  'cta.badge4': 'Resultados reales. Personas reales.',

  // Footer
  'footer.brand.desc': 'Creemos que todos merecen sentirse seguros con su sonrisa. Estamos aquí para hacerlo posible — de forma segura, honesta y con un médico real a tu lado.',
  'footer.cta': 'Reservar consulta',
  'footer.treatments': 'Tratamientos',
  'footer.company': 'Empresa',
  'footer.resources': 'Recursos',
  'footer.phone': 'Teléfono',
  'footer.email': 'Correo',
  'footer.location': 'Ubicación',
  'footer.locationValue': 'Estambul, Turquía',
  'footer.copyright': '© {{year}} Plexus Alliance. Todos los derechos reservados.',
  'footer.poweredBy': 'Desarrollado por Readdy',
  'nav.about': 'Nosotros',

  // About page
  'about.hero.badge': 'Nuestra historia',
  'about.hero.title': 'Construimos la red de seguridad que le faltaba al turismo dental',
  'about.hero.subtitle': 'Plexus Alliance se fundó con una creencia simple: los pacientes merecen una voz independiente en su propio tratamiento — especialmente cuando están lejos de casa.',
  'about.mission.badge': 'Nuestra misión',
  'about.mission.title': 'Atención dental transparente y supervisada para cada paciente, en todas partes.',
  'about.mission.desc': 'Conectamos a los pacientes con las mejores clínicas dentales de Estambul mientras proporcionamos la capa de supervisión independiente que la mayoría de las empresas de turismo dental simplemente no ofrecen.',
  'about.values.badge': 'En qué creemos',
  'about.values.title': 'Nuestros valores fundamentales',
  'about.value1.title': 'Independencia',
  'about.value1.desc': 'Nuestros supervisores solo responden ante ti — nunca ante la clínica.',
  'about.value2.title': 'Transparencia',
  'about.value2.desc': 'Cada registro, cada escáner, cada decisión — completamente visible para ti.',
  'about.value3.title': 'Continuidad',
  'about.value3.desc': 'Tu atención no se detiene cuando subes al avión de regreso.',
  'about.value4.title': 'Accesibilidad',
  'about.value4.desc': 'La atención dental de clase mundial no debería ser un privilegio. La hacemos accesible.',

  // Treatments page
  'treatments.hero.badge': 'Todos los tratamientos',
  'treatments.hero.title': 'Encuentra tu tratamiento',
  'treatments.hero.subtitle': 'Desde implantes individuales hasta cambios de sonrisa completos — cada tratamiento está supervisado, es transparente y tiene un precio justo.',
  'treatments.filter.all': 'Todos los tratamientos',
  'treatments.filter.implants': 'Implantes',
  'treatments.filter.cosmetic': 'Cosmético',
  'treatments.filter.orthodontics': 'Ortodoncia',
  'treatments.filter.restorative': 'Restaurador',
  'treatments.cta.title': '¿No estás seguro de qué tratamiento necesitas?',
  'treatments.cta.desc': 'Cuéntanos qué te molesta — revisaremos tu caso gratis y recomendaremos el camino correcto.',
  'treatments.cta.button': 'Obtener una evaluación gratuita',

  // Book Treatment page
  'book.hero.badge': 'Comienza tu viaje',
  'book.hero.title': 'Reserva tu tratamiento',
  'book.hero.subtitle': 'Completa los detalles a continuación y te responderemos en pocas horas con un plan personalizado.',
  'book.form.name': 'Nombre completo',
  'book.form.email': 'Dirección de correo',
  'book.form.phone': 'Teléfono / WhatsApp',
  'book.form.treatment': 'Tratamiento de interés',
  'book.form.supervision': 'Preferencia de supervisión',
  'book.form.message': 'Cuéntanos más (opcional)',
  'book.form.submit': 'Enviar mi solicitud',
  'book.form.submitting': 'Enviando...',
  'book.form.success': '¡Solicitud enviada! Nos pondremos en contacto en pocas horas.',

  // Partner Registration page
  'partner.hero.badge': 'Asóciate con nosotros',
  'partner.hero.title': 'Únete a la red Plexus Alliance',
  'partner.hero.subtitle': '¿Eres dentista, clínica o profesional de la salud? Asóciate con nosotros y gana mientras ayudas a tus pacientes a acceder a atención de clase mundial.',
  'partner.form.submit': 'Enviar solicitud',

  // How It Works page
  'hiw.hero.badge': 'El proceso',
  'hiw.hero.title': 'Cómo funciona',
  'hiw.hero.subtitle': 'Desde tu primer mensaje hasta tu último chequeo — aquí está exactamente lo que sucede, paso a paso.',
  'hiw.faq.title': '¿Todavía tienes preguntas?',
  'hiw.cta.title': '¿Listo para dar el primer paso?',
  'hiw.cta.subtitle': 'Comienza con un solo mensaje. Dinos qué necesitas — nosotros nos encargamos del resto.',
  'hiw.cta.button': 'Comenzar mi viaje',

  // Supervision page
  'sup.hero.badge': 'Tu protección',
  'sup.hero.title': 'Supervisión médica',
  'sup.hero.subtitle': 'Lo único que la mayoría de las empresas de turismo dental no ofrecen — y lo único que marca toda la diferencia.',
  'sup.why.title': 'La mayoría de las clínicas trabajan para sí mismas. Nosotros trabajamos para ti.',
  'sup.options.title': 'Tres formas de mantenerte protegido',
  'sup.pillars.title': 'Lo que recibe cada paciente supervisado',
  'sup.compare.title': 'Con supervisión vs. sin ella',
  'sup.faq.title': 'Preguntas sobre la supervisión',
  'sup.cta.title': 'Tu salud merece una voz independiente.',
  'sup.cta.button': 'Reservar con supervisión',

  // Common UI
  'common.learnMore': 'Saber más',
  'common.bookNow': 'Reservar ahora',
  'common.startJourney': 'Comenzar mi viaje',
  'common.getStarted': 'Empezar',
  'common.contactUs': 'Contáctanos',
  'common.readMore': 'Leer más',
  'common.viewAll': 'Ver todo',
  'common.close': 'Cerrar',
  'common.back': 'Atrás',
  'common.next': 'Siguiente',
  'common.loading': 'Cargando...',
  'common.error': 'Algo salió mal. Por favor, inténtalo de nuevo.',
  'common.required': 'Este campo es obligatorio',
  'common.optional': 'Opcional',
  'common.saving': 'Ahorro de',
  'common.perTooth': 'por diente',
  'common.included': 'Incluido',
  'common.mostTrusted': 'Más confiable',
  'common.mostComfortable': 'Más cómodo',
  'common.yearsExperience': 'años de experiencia',
  'common.patients': 'pacientes',
  'common.countries': 'países',
  'common.savings': 'ahorros',
};

export default common;
